import React, { useState, useEffect } from "react";
import Uploder from "../Uploader";
import { sortsDatas } from "../Datas";
import { Button, DatePickerComp, Input, Select } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { toast } from "react-hot-toast";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useFormik } from "formik";
import * as Yup from "yup";
import staffApi from "../../api/user/staff.api";
import { useNavigate } from "react-router-dom";
import ProcessingBar from "../ProcessingBar/ProcessingBar";
import ProcessingBar2 from "../ProcessingBar/ProcessingBar2";
import sericesApi from "../../api/user/service.api";
import TimeSlotSelector from "../TimeSlot";
import { MultiSelect } from "../MultiSelect";
import Loading from "../../Util/Loading";
import { useSelector } from "react-redux";

function PersonalInfo() {
  //send operator Id
  const user = useSelector((state) => state.user);

  console.log({ user });

  const operatorId = user?.user?._id || null;
  console.log({ operatorId });

  const navigate = useNavigate();
  const [gender, setGender] = React.useState(sortsDatas.genderFilter[0]);
  const [Images, setImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [nails, setNails] = useState([]);
  const [selectedNails, setSelectedNails] = useState([]);
  const [beauty, setBeauty] = useState([]);
  const [selectedBeauty, setSelectedBeauty] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getNailData(), getBeautyData()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const getBeautyData = async () => {
    try {
      const { response, err } = await sericesApi.getallBeauty({ operatorId });

      if (response && response.data) {
        setBeauty(response.data.beautyservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getNailData = async () => {
    try {
      const { response, err } = await sericesApi.getallNail({ operatorId });

      if (response && response.data) {
        setNails(response.data.nailservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    createStaffForm.setFieldValue("nailSelected", selectedNails || []);
    createStaffForm.setFieldValue("beautySelected", selectedBeauty || []);
    createStaffForm.setFieldValue("timeslot", timeSlots || []);
  }, [selectedNails, selectedBeauty, timeSlots]);

  const createStaffForm = useFormik({
    initialValues: {
      email: "",
      name: "",
      phone: "",
      gender: "",
      bio: "",
      photo: "",
      operator: user?.user?._id || null,
      nailSelected: [],
      beautySelected: [],
      dayselect: [],
      timeslot: [],
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format") // Ensures proper email format
        .min(3, "Email must be at least 3 characters")
        .required("Required"),
      name: Yup.string()
        .min(3, "Display name must be at least 3 characters")
        .required("Required"),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true, // ✅ Add this line
    onSubmit: async (values) => {
      const defaultPhotoUrl =
        "https://diamondnailsydney.s3.ap-southeast-2.amazonaws.com/staff.jpg";

      const submissionValues = {
        ...values,
        photo: values.photo?.trim() || defaultPhotoUrl,
      };
      console.log("Form values with photo:", submissionValues);
      try {
        const { response, err } = await staffApi.create(submissionValues);

        if (err) {
          const message =
            err?.response?.data?.message || "Failed to create staff";
          toast.error(message);
          return;
        }

        setIsUploading(true);

        if (response) {
          createStaffForm.resetForm();
          setIsUploading(false);
          toast.success("Create a new staff successfully");
          setTimeout(() => {
            navigate("/staffs");
          }, 1000);
        }
      } catch (error) {
        console.error(error);
        setErrorMessage(error.message);
        toast.error(error.message);
      }
    },
  });

  const updateImages = (newImageUrl) => {
    setImages([newImageUrl]);
    createStaffForm.setFieldValue("photo", newImageUrl || "");
  };

  if (isLoading) return <Loading />;

  return (
    <form
      onSubmit={createStaffForm.handleSubmit}
      className="space-y-4 z-[1000]"
    >
      <input
        type="text"
        name="name"
        placeholder="Enter Staff Name"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.name}
      />
      {createStaffForm.errors.email && createStaffForm.touched.name && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.name}</p>
      )}
      <input
        type="text"
        name="email"
        placeholder="Enter Email"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.email}
      />
      {createStaffForm.errors.email && createStaffForm.touched.email && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.email}</p>
      )}
      {/* <input
        type="text"
        name="phone"
        placeholder="Phone Number"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.phone}
      />
      {createStaffForm.errors.email && createStaffForm.touched.phone && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.phone}</p>
      )}
      <input
        type="text"
        name="bio"
        placeholder="Bio"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.bio}
      />
      {createStaffForm.errors.bio && createStaffForm.touched.bio && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.bio}</p>
      )}
      <Select
        selectedPerson={createStaffForm.values.gender}
        setSelectedPerson={
          (selected) => createStaffForm.setFieldValue("gender", selected.name) // Store only the name
        }
        datas={sortsDatas.genderFilter}
      >
        <div className="w-full bg-dry flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
          {createStaffForm.values.gender || "Select Gender"}{" "}
          <BiChevronDown className="text-xl" />
        </div>
      </Select>
      {createStaffForm.errors.gender && createStaffForm.touched.gender && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.gender}</p>
      )} */}
      {/* // select nail or beauty skills */}
      <MultiSelect
        title="Nail Skills"
        selectedItems={selectedNails}
        setSelectedItems={setSelectedNails}
        items={nails}
      />
      <MultiSelect
        title="Beauty Skills"
        items={beauty}
        selectedItems={selectedBeauty}
        setSelectedItems={setSelectedBeauty}
      />
      <TimeSlotSelector
        selectedDays={selectedDays}
        setSelectedDays={setSelectedDays}
        timeSlots={timeSlots}
        setTimeSlots={setTimeSlots}
      />

      <div className="flex gap-3 flex-col w-full col-span-6">
        <p className="text-sm text-text">Profile Image</p>
        <Uploder refreshFunction={updateImages} />
      </div>
      {createStaffForm.errors.photo && createStaffForm.touched.photo && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.photo}</p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
        <Button
          label={"Delete"}
          Icon={RiDeleteBin5Line}
          disabled={isUploading}
          onClick={() => {
            toast.error("This feature is not available yet");
          }}
        />
        <Button
          type="submit" // This now correctly submits the form
          label="Create"
          loading={isUploading}
          Icon={HiOutlineCheckCircle}
        />
      </div>
    </form>
  );
}

export default PersonalInfo;
